<template>
  <div class="skeleton">
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
    <div class="list-item">
      <div class="list-item__main">
        <!---->
        <div class="list-item__thumb">
          <div class="square circle"></div>
        </div>
        <div class="list-item__contents w-100px">
          <div class="list-item__contents__title w-100px">
            <div class="line h8"></div>
          </div>
        </div>
        <!---->
      </div>
      <!---->
    </div>
  </div>
</template>
<script>
export default {};
</script>
